import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { TFunction } from "i18next";

export const CALENDAR_PLUGINS = [
  dayGridPlugin,
  timeGridPlugin,
  interactionPlugin,
];

export const getCalendarToolbarOptions = (t: TFunction) => ({
  headerToolbar: {
    left: "prev,next today",
    center: "title",
    right: "timeGridDay timeGridWeek dayGridMonth",
  },
  buttonText: {
    today: t("taskHub.schedule.today") || "Today",
    day: t("taskHub.schedule.day") || "Day",
    week: t("taskHub.schedule.week") || "Week",
    month: t("taskHub.schedule.month") || "Month",
  },
});
